import { CountryIsoNumber, IEProvinceName } from '@i18n';
import { FormOption } from '../../../shared/models/form-option.interface';
import { formatAddressProvinceNameFormOptions } from '../../utils/address.utils';

export function addressProvinceFormOptionsFactory(
  countryIsoNumber?: CountryIsoNumber,
): FormOption[] | undefined {
  switch (countryIsoNumber) {
    case CountryIsoNumber.Ireland:
      return formatAddressProvinceNameFormOptions(IEProvinceName);
    case CountryIsoNumber.GreatBritain:
    default:
      return;
  }
}
